import CourseImage1 from "../../../../assets/images/png/individual/courses/course1.webp";
import CourseImage2 from "../../../../assets/images/png/individual/courses/course2.webp";
import CourseImage3 from "../../../../assets/images/png/individual/courses/course3.webp";
import CourseImage4 from "../../../../assets/images/png/individual/courses/course4.webp";

const learningDataAfrica = [
  {
    id: 1,
    image: CourseImage1,
    title: "Data Analyst (Accelerator)",
    url: "/courses/data-analytics-bootcamp",
    courseType: "For Data Enthusiast",
    courseLevel: "3 Months",
  },
  {
    id: 4,
    image: CourseImage2,
    title: "Product Management (Accelerator)",
    url: "/courses/product-management-and-design-bootcamp",
    courseType: "For Professionals",
    courseLevel: "12 Weeks",
  },
  // {
  //   id: 6,
  //   image: CourseImage2,
  //   title: "Product Design Bootcamp",
  //   url: "/courses/design-bootcamp",
  //   courseType: "For Starters",
  //   courseLevel: "6 Weeks",
  // },
  {
    id: 10,
    image: CourseImage4,
    title: "Blockchain Developer Program",
    url: "/courses/blockchain-developer-bootcamp",
    courseType: "For Starters",
    courseLevel: "6 Months",
  },

  {
    id: 5,
    image: CourseImage1,
    title: "Product Marketing Bootcamp",
    url: "/courses/product-marketing-bootcamp",
    courseType: "For Starters",
    courseLevel: "3 Months",
  },

  {
    id: 7,
    image: CourseImage3,
    title: "Become A Frontend Developer",
    url: "/courses/frontend-development",
    courseType: "For Starters",
    courseLevel: "2 Months",
  },
  {
    id: 8,
    image: CourseImage4,
    title: "Become A Backend Developer",
    url: "/courses/backend-development",
    courseType: "For Professionals",
    courseLevel: "8 Weeks",
  },
];

export default learningDataAfrica;
